import { render, staticRenderFns } from "./unverified-container.vue?vue&type=template&id=007ca7e0"
import script from "./unverified-container.vue?vue&type=script&lang=js"
export * from "./unverified-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports